import {
	Container,
	CrabBubbleContainer,
	CrabImage,
	DescriptionContainer,
	Message
	//SuperOfferTitle,
	//Title
} from "./styles";
import { endlessOfferAssets } from "assets/cdn";
import { useEffect, useState } from "react";
import { EndlessOfferResponse } from "interfaces/endless-offer";
import { featureTrackerAPI } from "redux/apis";
import { useWebStoreContext } from "contexts";
import { useImagePath } from "hooks";

interface Props {
	nextSuperOfferCount: number;
}

export const EndlessCrab: React.FC<Props> = ({ nextSuperOfferCount }) => {
	const { authToken } = useWebStoreContext();
	const [isBubble, setIsBubble] = useState(false);
	const { getImage } = useImagePath("cdn");
	const crabImage = getImage(endlessOfferAssets.crab.character);
	const crabBubbleImage = getImage(endlessOfferAssets.crab.bubble);

	const { data }: { data?: EndlessOfferResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: "endless-offer",
			isAuthenticated: !!authToken?.value
		});

	const character = data?.tracker?.themeConfig?.characterImageUrl ?? crabImage;

	useEffect(() => {
		const timer = setTimeout(() => setIsBubble(true), 2000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<Container>
			{isBubble && (
				<CrabBubbleContainer
					className="animate__animated animate__fadeIn"
					image={crabBubbleImage}
				>
					<DescriptionContainer>
						{nextSuperOfferCount === 0 ? (
							<>
								{/* <SuperOfferTitle>Super Offer</SuperOfferTitle> */}
								<Message>Super Offer</Message>
								<Message>is here!</Message>
							</>
						) : (
							<>
								{/* <Title>{nextSuperOfferCount} more till</Title> */}
								<Message>{nextSuperOfferCount} more &lsquo;til</Message>
								<Message>Super Offer</Message>
							</>
						)}
					</DescriptionContainer>
				</CrabBubbleContainer>
			)}
			<CrabImage
				className={
					nextSuperOfferCount === 0 ? "animate__animated animate__tada" : ""
				}
				src={character}
			/>
		</Container>
	);
};
